import React, { useState } from "react"
import _ from "lodash"
import Isvg from "react-inlinesvg"
// Components, Data
import RowAddRemove from "components/table/carousel/row-add-remove"
import { checkDateSet } from "data/lib/dates"
import { DateInput, DropdownInput, NumberInput, TextInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"
// Icons
import { CaretLeftIcon, CloseIcon } from "images/icons/general/"
// Styles
import { Button_s, H4 } from "styles/app-styles"
import { FormError_s } from "styles/form-styles"
import { MultiRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { CapButtons_s, DetailsButton_s, Details_s } from "components/market-lease/market-lease-styles"

type Item_t = object & {
  i: number
}

const RecoveriesDetailedAmt = (props: {rowData: [], field: string, defaults: {}, namedItems:object, persist: Function}) => {
  const initialItems         = _.get(props.rowData[props.field], "detailedAmtItems")
  const emptyDetailedItem = () => ({
    amt: null,
    date: null,
    i: 0
  })
  const emptyItem = () => ({
    name: null,
    amtType: props.defaults['recoveryDetailedAmtAmtType'],
    dateMode: 'absolute',
    items: [emptyDetailedItem()]
  })

  const [detailedItem, setDetailedItem] = useState<number>(0)
  const [showDetails, setShowDetails]   = useState<boolean>(true)
  const [homogenous, setHomogenous]     = useState<boolean>(true);
  const [items, setItems]               = useState<Item_t[]>(initialItems && initialItems.length ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem(), i:0}])

  function updateData(val:any, field:any[]):void {
    let nextItems = _.cloneDeep(_.get(props.rowData[props.field], "detailedAmtItems") || [emptyItem()])
    if (field[1] === 'name' && nextItems[field[0]]?.[field[1]] === null && val === '') return
    if (field[1] === 'date' || field[1] === 'amt'){
      if (!nextItems[detailedItem]['items']) nextItems[detailedItem]['items'] = [emptyDetailedItem()]
      if (field[1] === 'date'){
        let dateModeCheck = checkDateSet(val, nextItems[detailedItem]['items'])
        setHomogenous(dateModeCheck.homogenous);
        nextItems[detailedItem]['dateMode'] = dateModeCheck.dateMode || 'absolute'
      }
      nextItems[detailedItem]['items'][field[0]][field[1]] = val
    } else {
      nextItems[field[0]][field[1]] = val
    }
    setItems(nextItems.map((item, i) => { return {...item, i }}))
    nextItems = nextItems.map(({i, ...rest}) => rest)
    if (nextItems[detailedItem]['items']) nextItems[detailedItem]['items'] = nextItems[detailedItem]['items'].map(({i, ...rest}) => rest)
    let nextData = _.cloneDeep(props.rowData[props.field]) || {}
        nextData = {...nextData, 'detailedAmtItems': nextItems}
    props.persist(nextData, props.field, props.rowData)
  }


  function updateItems(updatedItems:Item_t[]):void {
    let nextData = _.cloneDeep(props.rowData[props.field]) || {}
    setItems(updatedItems)
    let nextItems:any = updatedItems.map(({i, ...rest}) => rest)
    if (items.length === 1 && updatedItems.length === 1) delete nextData['detailedAmtItems']
    else _.set(nextData, "detailedAmtItems", nextItems)
    props.persist(nextData, props.field, props.rowData)
  }

  function updateDetailedItems(updatedItems:object[]):void {
    let nextData  = _.cloneDeep(props.rowData[props.field]) || {}
    let nextItems = _.get(props.rowData[props.field], "detailedAmtItems")

    if (nextItems[detailedItem]['items'].length === 1 && updatedItems.length === 1){
      nextItems[detailedItem]['items'] = null
    } else {
      let strippedItems = _.cloneDeep(updatedItems).map(({i, ...rest}) => rest)
      nextItems[detailedItem]['items'] = strippedItems
    }
    nextData = {...nextData, 'detailedAmtItems': nextItems}
    props.persist(nextData, props.field, props.rowData)

    nextItems[detailedItem]['items'] = updatedItems
    nextItems = nextItems.map((item, i) => { return {...item, i }})
    setItems(nextItems)
  }

  function toggleDetails(row:object):void {
    let idx = row['i']
    setDetailedItem(idx)
  }

  function clearDetails():void {
    const empty_detail = emptyDetailedItem()
    updateData([empty_detail], [detailedItem, 'items'])
  }

  let renderItems = _.sortBy(items, 'i')

  const table = props.rowData['rentrollid'] ? 'rentroll' : 'marketlease'

  const params = {
    attrs: (field) => field_attrs(table, `${props.field}.detailedAmtItems`)(field)(props.rowData, props),
    data: items,
    persist: updateData
  }
  const detailedParams = (id) => ({
    attrs: (field) => field_attrs(table, `${props.field}.detailedAmtItems.${id}.items`)(field)(props.rowData, props),
    persist: updateData
  })

  const reportTagOptions = props.namedItems?.['reportTags']?.map(tag => {
    if (tag.code) return {label: tag.code, value: tag.reporttagid}
  })

  const detailedItems = renderItems[detailedItem]?.['items']?.map((item, i) => { return {...item, i }}) || [emptyDetailedItem()]

  return (
    <div className="detailed-amt-container">
      { renderItems.map((row:object, i:number) => (
          <MultiRowCarouselState_s className="carousel-multi-row recoveries">
            <div>
              { i === 0 && <label>Name</label> }
              <TextInput
                className="automated automation_hook_source_row_start"
                field={[row['i'], 'name']}
                onFocus={()=>toggleDetails(row)}
                {...params}
              />
            </div>
            <div>
              { i === 0 && <label>Amt Type</label> }
              <DropdownInput
                className="automated"
                field={[row['i'], 'amtType']}
                options={['/Mo', '/Yr', '/Area/Mo', '/Area/Yr']}
                default="/Area/Yr"
                onFocus={()=>toggleDetails(row)}
                {...params}
              />
            </div>
            <div>
            { i === 0 && <label>Report Tag</label> }
              <DropdownInput
                className={`automated automation_hook_S${i}`}
                field={[row['i'], 'reportTagNamedItemId']}
                options={reportTagOptions}
                onClear={() => updateData(null, [row['i'], 'reportTagNamedItemId'])}
                onFocus={()=>toggleDetails(row)}
                {...params}
              />
            </div>
            <RowAddRemove emptyRecord={emptyItem()} setState={updateItems} row={i} items={renderItems} />
          </MultiRowCarouselState_s>
        ))}
        <DetailsButton_s onClick={()=>setShowDetails(!showDetails)}><Isvg src={CaretLeftIcon} cacheGetRequests /><strong>Details</strong></DetailsButton_s>
        { showDetails && <Details_s>
          <CapButtons_s>
            <H4>{_.get(props.rowData[props.field], "detailedAmtItems")?.[detailedItem]?.name || ''}</H4>
            <div>
              <Button_s danger onClick={()=>clearDetails()}>Clear</Button_s>
              <a onClick={()=>setShowDetails(false)}><Isvg src={CloseIcon} cacheGetRequests /></a>
            </div>
          </CapButtons_s>
          <div className="detailed-amt-details">
          { (detailedItems).map((row:object, i:number) => (
            <MultiRowCarouselState_s className="carousel-multi-row">
              <div>
                { i === 0 && <label>Date</label> }
                <DateInput
                  className={`automated automation_hook_T${detailedItem}`}
                  field={[row['i'], 'date']}
                  allowRelative
                  withoutDays
                  data={detailedItems}
                  {...detailedParams(detailedItem)}
                />
              </div>
              <div>
                { i === 0 && <label>Amt</label> }
                <NumberInput
                  className={`automated automation_hook_T${detailedItem}`}
                  field={[row['i'], 'amt']}
                  min={-2e9}
                  max={2e9}
                  readPrecision={2}
                  writePrecision={2}
                  data={detailedItems}
                  {...detailedParams(detailedItem)}
                />
              </div>
              <RowAddRemove emptyRecord={{date: null, amt: null}} setState={updateDetailedItems} row={row['i']} items={detailedItems} />
            </MultiRowCarouselState_s>
        ))}
        </div>
        {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
      </Details_s> }
    </div>
  )
}

export default RecoveriesDetailedAmt

